export const HEADER_BUTTON_AREA_DOM_ID = "header-extra";

// Just render a DOM element that can be used as a portal target
export const HeaderButtonArea: React.FC = () => {
  return <div id={HEADER_BUTTON_AREA_DOM_ID}></div>;
};
